// Designer Connection Theme JS

(function() {
  'use strict';

  // ===== TOP BAR ROTATOR =====
  function initTopBar() {
    var bar = document.querySelector('.dc-top-bar');
    if (!bar) return;
    var messages = [];
    bar.querySelectorAll('.dc-top-bar__msg').forEach(function(el) {
      messages.push(el.textContent.trim());
    });
    if (messages.length < 2) return;
    var display = bar.querySelector('.dc-top-bar__text');
    if (!display) return;
    var idx = 0;
    setInterval(function() {
      display.classList.remove('animate-fade-in');
      void display.offsetWidth;
      idx = (idx + 1) % messages.length;
      display.textContent = messages[idx];
      display.classList.add('animate-fade-in');
    }, 3000);
  }

  // ===== HERO ROTATOR =====
  function initHero() {
    var slides = document.querySelectorAll('.dc-hero__slide');
    var dots = document.querySelectorAll('.dc-hero__dot');
    if (slides.length < 2) return;
    var current = 0;

    function goTo(n) {
      slides[current].style.opacity = '0';
      if (dots[current]) dots[current].classList.remove('is-active');
      current = n;
      slides[current].style.opacity = '1';
      if (dots[current]) dots[current].classList.add('is-active');
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { goTo(i); });
    });

    setInterval(function() {
      goTo((current + 1) % slides.length);
    }, 4000);
  }

  // ===== DRAWER MENU =====
  function initDrawer() {
    var trigger = document.querySelector('.dc-nav__menu-btn');
    var overlay = document.querySelector('.dc-drawer-overlay');
    var bgEl = overlay && overlay.querySelector('.dc-drawer-bg');
    var closeBtn = overlay && overlay.querySelector('.dc-drawer__close');

    function open() { if (overlay) overlay.classList.add('is-open'); }
    function close() { if (overlay) overlay.classList.remove('is-open'); }

    if (trigger) trigger.addEventListener('click', open);
    if (bgEl) bgEl.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    if (overlay) {
      overlay.querySelectorAll('.dc-drawer__link').forEach(function(link) {
        link.addEventListener('click', close);
      });
    }
  }

  // ===== PRODUCT CAROUSELS =====
  function initCarousels() {
    document.querySelectorAll('.dc-carousel-section').forEach(function(section) {
      var track = section.querySelector('.dc-carousel-track');
      var leftBtn = section.querySelector('.dc-carousel-btn--left');
      var rightBtn = section.querySelector('.dc-carousel-btn--right');
      if (!track) return;
      if (leftBtn) leftBtn.addEventListener('click', function() { track.scrollBy({ left: -280, behavior: 'smooth' }); });
      if (rightBtn) rightBtn.addEventListener('click', function() { track.scrollBy({ left: 280, behavior: 'smooth' }); });
    });
  }

  // ===== FAQ ACCORDION =====
  // Native <details> handles this — no JS needed

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    initTopBar();
    initHero();
    initDrawer();
    initCarousels();
  });

})();
